import styled, { css } from "styled-components";
import { Grid } from "../../../molecules/Grid/Grid.style";
import { InputProps } from "../Inputs";

interface InputFileStyleProps {
  width?: number;
}

export const InputFileListBox = styled.div<InputFileStyleProps>`
  display: flex;
  width: ${(props) => (props.width ? props.width + "px" : "auto")};
  flex-direction: column;
  gap: 4px;
  margin-top: 15px;
`;

export const InputFileListHeader = styled.div`
  display: flex;
  color: ${(props) => props.theme.colors.black60};
  font-size: 1.2rem;
  font-weight: 500;
  align-items: center;
  justify-content: space-between;
`;

export const InputFileListButtons = styled.div`
  display: flex;
  gap: 4px;
`;

export const InputFileListLabel = styled.label`
  display: flex;
  height: 28px;
  padding: 0 10px;
  color: ${(props) => props.theme.colors.primary100};
  font-size: 1.2rem;
  font-weight: 500;
  border: 1px solid ${(props) => props.theme.colors.primary100};
  border-radius: 6px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease;

  input {
    display: none;
  }

  &:hover {
    background: ${(props) => props.theme.colors.primary5};
  }
`;

export const InputFileList = styled.div`
  & > div {
    max-height: 30vh;
  }
  /* height: calc(100vh - 128px); */
  height: 200px;

  /* display: flex;
  padding: 20px;
  background: ${(props) => props.theme.colors.white100};
  border-radius: 6px;
  box-shadow: ${(props) => props.theme.shadows.field};
  flex-direction: column;
  gap: 16px; */

  ${Grid} {
    .dx-datagrid {
      .dx-datagrid-headers {
        td {
          height: 30px;
          padding: 0;

          .dx-datagrid-text-content {
            line-height: 30px;
          }
        }
      }

      .dx-datagrid-rowsview .dx-row.dx-data-row td {
        height: 30px;
        padding: 0;
      }
    }
  }
`;

export const InputFileListErroedTxt = styled.p`
  color: ${(props) => props.theme.colors.redStatus};
  font-size: 1.1rem;
  font-weight: 500;
  line-height: 16px;
  text-align: left;
`;

/**
 * [육상]
 */

interface InputFileProps {
  $placeholder?: boolean;
}

export const InputFileLabel = styled.label<InputProps>`
  display: flex;
  border: 1px solid ${(props) => props.theme.colors.black12};
  border-radius: 6px;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;

  input {
    display: none;
  }

  // SIZE
  ${(props) =>
    props.size === "md" &&
    css`
      height: 32px;
      padding: 0 10px;
      font-size: 1.2rem;
    `}

  ${(props) =>
    props.size === "lg" &&
    css`
      height: 48px;
      padding: 0 16px;
      font-size: 1.4rem;
    `}
`;

export const InputFilePlaceholder = styled.div<InputFileProps>`
  overflow: hidden;
  width: calc(100% - 20px);
  color: ${(props) => props.theme.colors.black80};
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;

  ${(props) =>
    props.$placeholder &&
    css`
      color: ${(props) => props.theme.colors.black38};
    `};
`;
